import { ReactAxiosInterceptorConfig } from '../axios/ReactAxiosInterceptorConfig';
import {
   initializeAxios,
   initializeEnvironment,
   initializeTestEnvironment,
   RequestConfig,
   UniFocusEnvironment
} from '@unifocus/js-utils';

/**
 * Initialize the react test environment.
 * @param applicationId - The id of the application.
 * @param onReady - The function to call when the environment is ready.
 */
export const initializeReactTestEnvironment = (applicationId: string,
                                               onReady: (environment: UniFocusEnvironment) => void) => {
   initializeTestEnvironment(applicationId, (environment: UniFocusEnvironment): void => {
      initializeAxios(new ReactAxiosInterceptorConfig({
                                                         disableErrorHandling: true,
                                                         disableLoadMasking: true
                                                      }));

      fadeLoadingAnimation();

      onReady(environment);
   });
};

/**
 * Initialize the react test environment.
 * @param applicationId - The id of the application.
 * @param defaultAxiosRequestConfig - The default Axios RequestConfig
 * @param onReady - The function to call when the environment is ready.
 */
export const initializeReactTestEnvironmentWithDefaultAxiosConfig = (applicationId: string,
                                                                     defaultAxiosRequestConfig: RequestConfig,
                                                                     onReady: (environment: UniFocusEnvironment) => void) => {
   initializeTestEnvironment(applicationId, (environment: UniFocusEnvironment): void => {
      initializeAxios(new ReactAxiosInterceptorConfig(defaultAxiosRequestConfig));

      fadeLoadingAnimation();

      onReady(environment);
   });
};

/**
 * Initialize the react environment.
 * @param applicationId - The id of the application.
 * @param onReady - The function to call when the environment is ready.
 */
export const initializeReactEnvironment = (applicationId: string,
                                           onReady: (environment: UniFocusEnvironment) => void) => {
   initializeEnvironment(applicationId, (environment: UniFocusEnvironment): void => {
      initializeAxios(new ReactAxiosInterceptorConfig({
                                                         disableErrorHandling: true,
                                                         disableLoadMasking: true
                                                      }));

      fadeLoadingAnimation();

      onReady(environment);
   });
};

export const initializeReactEnvironmentWithDefaultAxiosConfig = (applicationId: string,
                                                                 defaultAxiosRequestConfig: RequestConfig,
                                                                 onReady: (environment: UniFocusEnvironment) => void) => {
   initializeEnvironment(applicationId, (environment: UniFocusEnvironment): void => {
      initializeAxios(new ReactAxiosInterceptorConfig(defaultAxiosRequestConfig));

      fadeLoadingAnimation();

      onReady(environment);
   });
};

const fadeLoadingAnimation = () => {
   const unifocusLoadingDiv = document.getElementById("unifocus-loading-div");

   if (unifocusLoadingDiv) {
      let opacity = 1;  // initial opacity

      const interval = setInterval(() => {
         if (opacity <= 0.1) {
            clearInterval(interval);

            if (unifocusLoadingDiv.parentNode) {
               unifocusLoadingDiv.parentNode.removeChild(unifocusLoadingDiv);
            }
         }

         unifocusLoadingDiv.style.opacity = opacity.toString();
         unifocusLoadingDiv.style.filter = 'alpha(opacity=' + opacity * 100 + ")";
         opacity -= opacity * 0.1;
      }, 20);
   }
};
